import { NavHashLink } from 'react-router-hash-link';
import logo from '../img/Air NZ Wordmark_white.png';
import mobileLogo from '../img/Air NZ logo.png';
//import booknow from '../img/Book Now Button.png';
//import { useRef } from 'react';
//import { useEffect } from 'react';

//const Navbar = ({ isWinterEscapeVisible }) => {
//  const booknowStickyBtn = useRef(null)//

//  useEffect(() => {
//    if (isWinterEscapeVisible) {
//      booknowStickyBtn.current.classList.add('btn-fade-out')
//    } else {
//      booknowStickyBtn.current.classList.remove('btn-fade-out')
//    }
//  }, [isWinterEscapeVisible])
const Navbar = () => {
  return (
    <>
      <nav className="navbar position-fixed">
        <div className="navbar-wrap">
          <ul className="navbar-nav d-flex align-items-center flex-wrap flex-row justify-content-between">
            <li className="nav-item">
              <a data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample">ABOUT</a>
            </li>
            <li className="nav-item title">
              <NavHashLink to='/home#'>Winter Fly-deas</NavHashLink>
              {/*<a className="mobile" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample">Winter Fly-deas</a>*/}
            </li>
            <li className="nav-item navbar-brand">
              <a href="https://www.airnewzealand.com.sg" target="_blank"><img className="desktop" src={logo} alt="logo" />
                <img className="mobile" src={mobileLogo} alt="logo" />
              </a>
            </li>
          </ul>
        </div>
      </nav>
      <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
        <div className="offcanvas-body-wrap d-flex flex-wrap justify-content-center align-items-center">
          <div className="offcanvas-header">
            <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div className="offcanvas-body text-center px-5">
            <span>About</span>
            <h2 className="mt-0">Winter<br />Fly-deas</h2>
            <p className="pt-4 ">Did you know that winter season in New Zealand starts in June? Whether you're seeking adventure or a relaxing retreat, get inspired with Air New Zealand to find your ideal winter escape.</p>
            {/*<button data-bs-dismiss="offcanvas" aria-label="Close" className="landing-btn mt-3"><NavHashLink to='/home#' className="mobile">
              Home</NavHashLink>
  </button>*/}
          </div>
        </div>
      </div>
      {/*<div ref={booknowStickyBtn} className="booknow-sticky">
        <a href="https://flightbookings.airnewzealand.com.sg/vbook/actions/ext-search" target="_blank"><img className="bookNow-btn" src={booknow} alt="booknow" /></a>
  </div>*/}
    </>
  );
};
export default Navbar;
